import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MockDataService {
  public getMockedRecurringRanking(_isActive: boolean) {
    const recurringRanking = {
      isActive: _isActive,
      trophyRanking: [
        {
          userId: 'f7c46a72-8450-47e2-a011-eba4cf7c7774',
          rankingPosition: 0,
          nickName: 'guest',
          score: 57200.0,
          isFriend: false,
        },
        {
          userId: 'f7c46a72-8450-47e2-a011-eba4cf7c7774',
          rankingPosition: 1,
          nickName: 'guest',
          score: 31000.0,
          isFriend: false,
        },
        {
          userId: 'f7c46a72-8450-47e2-a011-eba4cf7c7774',
          rankingPosition: 2,
          nickName: 'guest',
          score: 16000.0,
          isFriend: true,
        },
        {
          userId: 'f7c46a72-8450-47e2-a011-eba4cf7c7774',
          rankingPosition: 3,
          nickName: 'guest',
          score: 16000.0,
          isFriend: false,
        },
        {
          userId: 'f7c46a72-8450-47e2-a011-eba4cf7c7774',
          rankingPosition: 4,
          nickName: 'guest',
          score: 5800.0,
          isFriend: false,
        },
        {
          userId: 'f7c46a72-8450-47e2-a011-eba4cf7c7774',
          rankingPosition: 5,
          nickName: 'guest',
          score: 5200.0,
          isFriend: false,
        },
        {
          userId: 'f7c46a72-8450-47e2-a011-eba4cf7c7774',
          rankingPosition: 6,
          nickName: 'guest',
          score: 5200.0,
          isFriend: true,
        },
        {
          userId: 'f7c46a72-8450-47e2-a011-eba4cf7c7774',
          rankingPosition: 7,
          nickName: 'guest',
          score: 5000.0,
          isFriend: false,
        },
        {
          userId: 'f7c46a72-8450-47e2-a011-eba4cf7c7774',
          rankingPosition: 8,
          nickName: 'guest',
          score: 5000.0,
          isFriend: false,
        },
        {
          userId: 'f7c46a72-8450-47e2-a011-eba4cf7c7774',
          rankingPosition: 9,
          nickName: 'guest',
          score: 5000.0,
          isFriend: false,
        },
        {
          userId: 'f7c46a72-8450-47e2-a011-eba4cf7c7774',
          rankingPosition: 10,
          nickName: 'guest',
          score: 5000.0,
          isFriend: false,
        },
        {
          userId: 'f7c46a72-8450-47e2-a011-eba4cf7c7774',
          rankingPosition: 11,
          nickName: 'guest',
          score: 5000.0,
          isFriend: false,
        },
        {
          userId: 'f7c46a72-8450-47e2-a011-eba4cf7c7774',
          rankingPosition: 12,
          nickName: 'guest',
          score: 5000.0,
          isFriend: false,
        },
        {
          userId: 'f7c46a72-8450-47e2-a011-eba4cf7c7774',
          rankingPosition: 13,
          nickName: 'guest',
          score: 5000.0,
          isFriend: false,
        },
        {
          userId: 'f7c46a72-8450-47e2-a011-eba4cf7c7774',
          rankingPosition: 14,
          nickName: 'guest',
          score: 5000.0,
          isFriend: false,
        },
        {
          userId: 'f7c46a72-8450-47e2-a011-eba4cf7c7774',
          rankingPosition: 15,
          nickName: 'guest',
          score: 5000.0,
          isFriend: false,
        },
        {
          userId: 'f7c46a72-8450-47e2-a011-eba4cf7c7774',
          rankingPosition: 16,
          nickName: 'guest',
          score: 5000.0,
          isFriend: false,
        },
        {
          userId: 'f7c46a72-8450-47e2-a011-eba4cf7c7774',
          rankingPosition: 17,
          nickName: 'guest',
          score: 5000.0,
          isFriend: false,
        },
        {
          userId: 'f7c46a72-8450-47e2-a011-eba4cf7c7774',
          rankingPosition: 18,
          nickName: 'guest',
          score: 5000.0,
          isFriend: false,
        },
        {
          userId: 'f7c46a72-8450-47e2-a011-eba4cf7c7774',
          rankingPosition: 19,
          nickName: 'guest',
          score: 5000.0,
          isFriend: false,
        },
        {
          userId: 'f7c46a72-8450-47e2-a011-eba4cf7c7774',
          rankingPosition: 20,
          nickName: 'guest',
          score: 5000.0,
          isFriend: false,
        },
        {
          userId: 'f7c46a72-8450-47e2-a011-eba4cf7c7774',
          rankingPosition: 21,
          nickName: 'guest',
          score: 5000.0,
          isFriend: false,
        },
        {
          userId: 'f7c46a72-8450-47e2-a011-eba4cf7c7774',
          rankingPosition: 22,
          nickName: 'guest',
          score: 5000.0,
          isFriend: false,
        },
        {
          userId: 'f7c46a72-8450-47e2-a011-eba4cf7c7774',
          rankingPosition: 23,
          nickName: 'guest',
          score: 5000.0,
          isFriend: false,
        },
        {
          userId: 'f7c46a72-8450-47e2-a011-eba4cf7c7774',
          rankingPosition: 24,
          nickName: 'guest',
          score: 5000.0,
          isFriend: false,
        },
      ],
    };

    return recurringRanking;
  }
}
